// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__RrWRq","loaderImg":"Loader_loaderImg__XYrdD","wobble-pulse":"Loader_wobble-pulse__h8fvr","loaderStarting":"Loader_loaderStarting__mjrAb"};